<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>

        <!-- 测试开始 -->
        <img :src="imageUrlone" alt="" class="imgoneru">
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;background-color: white;height: 20vh;padding-top: 10vh;">
            <img style="margin-bottom: 4vh; height: 4vh; width: auto" :src="tenttwo.imageUrltwo" alt="">
            <div style="font-size: 2rem;">{{ isEnglish ? tenttwo.texttwoen:tenttwo.texttwo}}</div>
        </div>
       
<!-- 箱包的保养 -->
        <div style=" display:flex;flex-direction: column; align-items: flex-start; padding-left: 17.5vw; margin-top: 5vh;gap: 0vh;">
            <div style="padding-left: 2.6vw; font-weight: bold;font-size: 1rem;">{{ isEnglish ? tenttfour.titleoneen:tenttfour.titleone}}</div>
            <ul style="margin-top: 3vh; margin-left:2.3vh">
                <li v-for="(item, index) in (isEnglish ? tenttfour.contenten : tenttfour.content)" :key="index + item" style="font-size: 1rem; margin-left: 1.5vw;line-height: 2;">
                 {{ item }}
            </li>
              
            </ul>
            <div style="margin-top:3vh;color: gray;font-size: 0.8rem;padding-left: 2.6vw;">{{ isEnglish ? tenttfour.remarkeren:tenttfour.remarker}}</div>
        </div>

        <div style="margin-top: 8vh; width: 60vw; margin-left: 20vw; border-bottom: 1px solid gray;"></div>

<!-- 箱包乘机标准 -->
<div style=" display:flex;flex-direction: column; align-items: flex-start; padding-left: 17.5vw; margin-top: 8vh;gap: 0vh;">
    <div style="padding-left: 2.6vw; font-weight: bold;font-size: 1rem;">{{ isEnglish ? tenttfoursc.titleoneen:tenttfoursc.titleone}}</div>
    <ul style="margin-top: 3vh; margin-left:2.3vh">
        <li v-for="(item, index) in (isEnglish ? tenttfoursc.contenten : tenttfoursc.content)" :key="index" style="font-size: 1rem; margin-left: 1.5vw;line-height: 2;">
         {{ item }}
    </li>
    <div style="height: 2vh;width:20vw"></div>
    <li v-for="(item, index) in (isEnglish ? tenttfoursc.contenttwoen : tenttfoursc.contenttwo)" :key="item+index" style="font-size: 1rem; margin-left: 1.5vw;line-height: 2; ">
        {{ item }}
   </li>
    </ul>
    <div style="margin-top:3vh;color: gray;font-size: 0.8rem;padding-left: 2.6vw;">{{ isEnglish ? tenttfoursc.remarkeren:tenttfoursc.remarker}}</div>
</div>



    
        <Bottom style="margin-top: 13vh;"></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'
   
    import Bottom from "@/view/public/bottompc.vue";
    import { mapActions, mapState } from 'vuex';
    import axios from 'axios';
import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
 
    export default {
        computed: {
            // 从 Vuex 的 state 中获取 isEnglish 数据
            ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),

           // 使用 computed 属性来拼接 URL
                    uploadAction() {
                    return `${apiUrls.baseUrl}/website/dev-api/common/upload`;
                    },
             
        },
        components:{
            // Header2,
            Header,
            // Bottom2,
            Bottom
        },
        data() {
            return { 


              

                tenttwo:{
                    imageUrltwo: require('../../assets/logotuteng.png'),
                    texttwo:'常见问题',
                    texttwoen:'Foire aux questions',
                },
               
                tenttfour:{
                    titleone:'箱包的保养',
                    titleoneen:'Maintenance of luggage',
                   content:[
                    '避免尖锐的物品刮划箱体表面,使用是尽量用箱套保护。',
                    '长时间使用后可在轮子轴心滴少许润滑油。',
                    '箱包在半年不使用的情况下,请人工滚动轮子,因产品使用的轮子为环保材料,如长期不用会有风化现象。',
                    '购买商品后超过7天退、换货期限。',
                    '箱包不用时请用塑胶袋或箱套套上。',
                    '箱包尽量立放，不要平放且不要长时间压放重物,以免造成永久变形。',
                    '盛装较多物品后箱子要平放开合，且开箱时注意面板是否变型。',
                    '清洁时用中性洗洁剂擦试，勿用肥皂、洗衣粉或其它强酸，强碱的化学物品。'
                   ],
                   contenten:[
                    'Avoid sharp objects from scratching the surface of the box, and try to protect it with a case cover as much as possible.',
                    'After long-term use, a little lubricating oil can be dropped on the shaft of the wheel.',
                    'If the luggage is not used for half a year, please roll the wheels manually, because the wheels used in the product are environmentally friendly materials, and there will be weathering if not used for a long time.',
                    'After the purchase of the product, the return and exchange period exceeds 7 days.',
                    'When the bag is not in use, please use a plastic bag or box sleeve to cover it.',
                    'Bags should be placed vertically as much as possible, not flat and not pressed for a long time, so as not to cause permanent deformation.',
                    'After containing more items, the box should be closed flat, and pay attention to whether the panel is deformed when unpacking.',
                    'When cleaning, use neutral detergent to test, do not use soap, laundry detergent or other strong acid, strong alkali chemicals.'
                   ],
                
                   remarker:'注:如在空运过程中造成箱包损坏,可直接向航空公司索赔。',
                   remarkeren:'Note: If the bag is damaged during air transportation, you can claim directly from the airline.',
                },

                tenttfoursc:{
                    titleone:'箱包乘机标准',
                    titleoneen:'Bags and bags boarding standards.',
                   content:[
                    '登机箱常用标准(经济仓)。',
                    '重量:7公斤以下。',
                    '尺寸:三边之和115CM以下(长53CM*宽40CM*厚22CM)。',
                    '谱祺登机箱尺寸:20“以下(含20”)(1英寸等于2.54CM)。',
                    '机内行李仓尺寸:长200CM*宽48CM*厚28CM(波音737/7571747，空客319/320/321等大中型飞机)。',
                   ],
                   contenten:[
                    'The common standard of carry-on suitcases (economy class).',
                    'Weight: up to 7 kg.',
                    'SIZE: THE SUM OF THE THREE SIDES IS 115CM OR LESS (LENGTH 53CM * WIDTH 40CM * THICKNESS 22CM).',
                    'Size of Spectrum Carry-on Suitcase: 20" or less (including 20") (1 inch is equal to 2.54CM).',
                    'SIZE OF THE BAGGAGE COMPARTMENT IN THE AIRCRAFT: LENGTH 200CM * WIDTH 48CM * THICKNESS 28CM (Boeing 737/7571747, Airbus 319/320/321 AND OTHER LARGE AND MEDIUM-SIZED AIRCRAFT).',
                   ],

                   contenttwo:[
                    '托运箱常用标准(经济仓)。',
                    '重量:20公斤以下。',
                    '尺寸:长/宽/厚三边之和在158CM之下。',
                    '托运箱尺寸:30”左右',
                   ],
                   contenttwoen:[
                    'Common standard for consignment boxes (economy warehouse).',
                    'Weight: up to 20 kg.',
                    'Size: The sum of the three sides of length/width/thickness is less than 158CM.',
                    'Consignment box size: about 30".',
                   ],
                
                   remarker:'注:具体细则请咨询对应航司的登机托运规则。',
                   remarkeren:'Note: For specific details, please consult the boarding and check-in rules of the corresponding airline.',
                },
                 
              
               

                imageUrlone: require('../../assets/kehufuwus15-15.png'),
                imageUrltwo: require('../../assets/logotuteng.png'),
                isScrolled: false,
        
            };
        },

        mounted() {
            // this.fetchData();
            this.initObserver(); // 初始化观察器
             window.addEventListener('wheel', this.initObserver, { passive: false });
           

        },
        beforeDestroy() {
            window.removeEventListener('wheel', this.initObserver);
            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {

          



            async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/aftersales`);
                const data = response.data;
                console.log(data)
                if (data && data.length > 0) {
                    // 处理 banner 图片
                    this.imageUrlone = `${apiUrls.devApi}${data[0].imageUrlone}`;
                    // 分批赋值
                    this.throttledAssignData(data);
                 
                   
                }
            } catch (error) {
                console.error('获取数据失败:', error);
            }
        }, 
        /**
         * 
         * @param html 文本提取
         */
        stripHTMLTags(html) {
        // 创建一个 DOMParser 实例
        const parser = new DOMParser();
        // 将 HTML 字符串解析成文档对象
        const doc = parser.parseFromString(html, 'text/html');
        // 获取文档体的纯文本内容
        return doc.body.textContent || '';
    },
    /**
     * 
     * @param html li文本提取
     */
    stripHTMLTags2(html) {
        // 创建一个 DOMParser 实例
        const parser = new DOMParser();
        // 将 HTML 字符串解析成文档对象
        const doc = parser.parseFromString(html, 'text/html');
        // 提取所有 <li> 元素的文本内容，并存入数组
            return Array.from(doc.querySelectorAll('li')).map(item => item.textContent.trim());
    },
            /**
             * 
             * @param html 重要说明的数据提取
             */
            extractTextByTag(html) {
            // 创建一个 DOMParser 实例
            const parser = new DOMParser();
            // 将 HTML 字符串解析为文档对象
            const doc = parser.parseFromString(html, 'text/html');
            
            // 定义一个对象，用于按标签类型存储文本
            const groupedText = {};

            // 遍历文档中的所有子元素
            Array.from(doc.body.children).forEach(node => {
                const tagName = node.tagName.toLowerCase(); // 获取标签名
                const textContent = node.textContent.trim(); // 获取纯文本并去除空白

                if (textContent) {
                    // 如果对应标签的数组不存在，则初始化
                    if (!groupedText[tagName]) {
                        groupedText[tagName] = [];
                    }
                    // 将文本加入对应标签的数组
                    groupedText[tagName].push(textContent);
                }
            });

            return groupedText;
        },
         throttledAssignData(data) {
            // 定义赋值的节奏
            const steps = [
                () => {
                    this.tenttwo.imageUrltwo = `${apiUrls.devApi}${data[0].imageUrltwo}`;
                    this.tenttwo.texttwo=data[0].tenttwotexttwo;
                    this.tenttwo.texttwoen=data[0].tenttwotexttwoen;
                   
                  
                  this.tenttfour.titleone=data[0].tenttfourtitleone;
                  this.tenttfour.titleoneen=data[0].tenttfourtitleoneen;
                  // 提取 tenttfourcontent 中的纯文本内容
                    this.tenttfour.content = this.stripHTMLTags2(data[0].tenttfourcontent);
                     // 提取 tenttfourcontent 中的纯文本内容
                     this.tenttfour.contenten = this.stripHTMLTags2(data[0].tenttfourcontenten);
                     this.tenttfour.remarker = data[0].remarker;
                     this.tenttfour.remarkeren = data[0].remarkeren;


                },
                () => {
                   
                  
                                    // 将返回的路径字符串分割为数组
                const imagePaths = data[0].servicesimgSrc.split(','); // 将路径字符串分割为数组
                const servicestitle= data[0].servicestitle.split(';'); // 将路径字符串分割为数组
                const servicestitleen= data[0].servicestitleen.split(';'); // 将路径字符串分割为数组
                const description=this.stripHTMLTags(data[0].servicesdescription).match(/[^。]+。/g) || [];
                const descriptionen=this.stripHTMLTags(data[0].servicesdescriptionen).match(/[^。]+。/g) || [];
                
                
                  
                },
                () => {
                    
                    // console.log(this.zhoangyaoshuoming.items)
                },
                () => {
                    
                     // 提取所有问题
                    let match;
                    while (match = questionPattern.exec(content2)) {
                        questions.push(match[1].trim());  // 将问题内容去掉多余的空格，保存到数组
                    }

                  
                    


                 
                }
            ];

            let stepIndex = 0;

            const assignNextStep = () => {
                if (stepIndex < steps.length) {
                    steps[stepIndex](); // 执行当前赋值步骤
                    stepIndex++;

                    // 使用 setTimeout 控制下一次赋值节奏
                    setTimeout(assignNextStep, 100); // 每次间隔 100ms
                } else {
                    console.log('所有数据赋值完成');
                }
            };

            assignNextStep(); // 开始逐步赋值
        },
            initObserver() {
                // console.log(this.isEnglish)
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
                const ss=   options.root.scrollTop;
                if(ss!=0){
                    this.isScrolled = true;
                }else{ this.isScrolled=false;}


            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }
                     // 获取每个section元素
                     const sectionElements = this.$refs.sectionElement;
                     // 计算当前应该滚动到哪个section
                     const direction = event.deltaY > 0 ? 1 : -1; // 根据滚动方向确定是向上还是向下
                     // 计算滚动后的位置
                    this.scrollCount += direction;
                    // 防止越界
                    if (this.scrollCount < 0) this.scrollCount = 0;
                    if (this.scrollCount >= sectionElements.length) this.scrollCount = sectionElements.length - 1;

                    // 使用 scrollIntoView 确保滚动到该 section
                    const targetSection = sectionElements[this.scrollCount];
                    if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // 使目标元素在视口的垂直方向居中
                        inline: 'center' // 水平方向居中（可选）
                    });
                    }




                    const scrollHeight = scrollContainer.scrollHeight;
                    const containerHeight = scrollContainer.clientHeight;
                    // 检查滚动位置并设置 isScrolled
                    // 滚动状态判断
                    const scrollTop = scrollContainer.scrollTop;
                    if (scrollTop === 0) {
                        this.isScrolled = false;
                    } else if (scrollTop + containerHeight >= scrollHeight) {
                        this.isScrolled = true;
                    } else {
                        this.isScrolled = true;
                    }
                    let height;
                        height = window.innerHeight;
                        
                        scrollContainer.scrollBy({

                            top: event.deltaY > 0 ? height : -height,
                            behavior: 'smooth'
                        });


                    this.scrollCount += 1; // 增加滚动计数
                    // 等待 DOM 更新后再检查可见的 sections
                  

                        // 重新添加 fadeIn 类到当前可见的 .content
                        //this.checkVisibleSections(); // 检查可见的 sections

                       




                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>
/*? -------------------------------------------*/
 /* 按钮样式 */
 .submit-btn {
    width: 6vw;
    padding: 1.5vh;
    background-color: #333;
    color: white;
    font-size: 0.8rem;
    font-weight: bold;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.3s;
    margin-left: 12.2vw;
    
}
.submit-btn:hover {
    background-color: #555;
}

.fomeillustrate{
display: flex;
flex-direction: column;      /* 子元素垂直排列 */
justify-content: center;     /* 垂直方向居中 */
align-items: center;         /* 水平方向居中 */
margin-top: -3vh;
/* height: 40vh; */
margin-bottom: 8vh;

}
.fomeillustrate .title{
width: 60vw;
font-weight: bold;
font-size: 1.5rem;
margin-bottom: 5vh;
}

/* 表单容器样式 */
.form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    /* min-height: 100vh; */
    background-color: white;

}

.form-container .custom-form{
  width: 60vw;
  /* background-color: white; */
  border-radius: 5px;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
}
.form-container .custom-form .form-group {
    margin-bottom: 6vh;
    display: flex;
    align-items: center;
    gap: 3vw;
    
}
.form-container .custom-form .form-group label {
    width: 9vw; /* 标签宽度，保持对齐 */
    font-size: 1rem;
    color: #333;
    text-align: left;
    
}
.form-container .custom-form .form-group input, textarea {
    flex: 1;
    padding: 1vw;
    border: 1px solid #ddd;
    /* border-radius: 3px; */
    background-color: #f5f5f5;
    font-size: 14px;
    color: #333;
    outline: none;
    transition: border-color 0.3s;

}

textarea {
    resize: none; /* 禁止调整大小 */
    height: 10vh;
}


.illustrate{
display: flex;
flex-direction: column;      /* 子元素垂直排列 */
justify-content: center;     /* 垂直方向居中 */
align-items: center;         /* 水平方向居中 */
margin-top: 5vh;
height: 45vh;

}
.illustrate .title{
width: 60vw;
font-weight: bold;
font-size: 1.5rem;
margin-bottom: 3vh;


}
.illustrate .contentphone{
width: 60vw;

font-size:1rem;
line-height: 2;
color: gray;
white-space: pre;
}
.illustrate .contentemail{
width: 60vw;
font-size:1rem;
line-height: 2;
color: gray;
white-space: pre;

}
/*? -------------------------------------------*/








/* 台式大电脑 (1200px 及以上) 样式 */
@media (min-width: 1600px) {
    .xiahuaxian{
        margin-top: 54vh!important;
    }
}
/* 第一张图片开始 */
.imgone img{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
.imgoneru{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
/* 第一张图片结束 */
    .fadeIn {
        animation: fade-in ease 2s !important; /* 添加 !important 提高优先级 */
        animation-fill-mode: forwards;
    }
    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(100px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .red{
        background-color: red;
    }
/*整体布局开始*/
.boddy {
height: 100vh;
background-color: white;


overflow-y: auto; /* 允许垂直滑动 */
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: none;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {

    .titlehed{
        display: block!important;
        height: 10rem!important;
    }

}
/*手机端样式结束*/
</style>
